// Égalité de CONTENU entre deux lots de données relus en base.
//
// Pourquoi : les rafraîchissements de fond renvoient toujours de NOUVEAUX
// objets, même quand rien n'a bougé côté serveur. Chaque `setState` remplaçait
// alors l'identité du tableau, invalidait tous les `useMemo` en aval et faisait
// rejouer les animations des graphes : l'interface clignotait sans qu'aucune
// donnée n'ait changé. En comparant le contenu, on garde l'ancien tableau —
// React ne re-rend rien.
//
// Coût mesuré : ~10 ms pour 2 700 leads (≈3,8 Mo sérialisés), une fois par
// rafraîchissement. Bien moins qu'un rendu complet de l'arbre.

/** true si les deux lots portent exactement les mêmes lignes, dans le même ordre. */
export function sameRows(a, b) {
  if (a === b) return true;
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  if (a.length === 0) return true;
  return JSON.stringify(a) === JSON.stringify(b);
}

/** true si les deux objets ont le même contenu (null/undefined compris). */
export function sameObject(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  return JSON.stringify(a) === JSON.stringify(b);
}

/**
 * Réducteur de `setState` qui conserve la valeur précédente quand le contenu
 * est identique : `setLeads(keepIfSame(nouvellesLignes))`.
 */
export function keepIfSame(next, equals = sameRows) {
  return (prev) => (equals(prev, next) ? prev : next);
}
